/* eslint-disable no-nested-ternary */
/* eslint-disable no-continue */
/* eslint-disable consistent-return */
/* eslint-disable no-restricted-syntax */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/click-events-have-key-events */
// import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { Box, Divider } from "@mui/material";
import { Formik } from "formik";
import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import * as Sentry from "@sentry/react";
import Toast from "../../../../components/common/Toast";
import FamilySubHeader from "../../../../components/FamilySubHeader/FamilySubHeader";
import { FAMILY_FIELDS } from "../../../../contants/formFields";
import { selectUserProfile } from "../../../../redux/selectors/user";
import Family from "../../../../services/api/Family";
import { debounce, isEmptyObj } from "../../../../utils/helper";
import AddressForm from "./AddressForm/AddressForm";
import Styles from "./FamilyForm.styles";
import FamilyRelation from "./FamilyRelationForm/FamilyRelation";
import MemberRow from "./MemberRow/MemberRow";
import Typography from "../../../../components/common/new/Typography/Typography";
import Loader from "../../../../components/common/Loader/Loader";

const createMember = (data) => ({
  id: data.id,
  memberId: data.memberId ?? "",
  isSameOrg: data.isSameOrg ?? false,
  name: data.name ?? "",
  gohonzon: data.gohonzon ?? false,
  subscription: data.subscription ?? "",
  divisionName: data.divisionName ?? "",
});

const createFamilyRelation = (data) => ({
  id: data.id,
  relatedMemberId: data.relatedMemberId ?? "",
  relationType: data.relationType ?? "",
  memberId: data.memberId ?? "",
});

const isValidFamiltMember = (data) =>
  Boolean(data.relatedMemberId && data.relationType && data.memberId);

function FamilyForm({ isEdit = false }) {
  const [members, setMembers] = useState([createMember({ id: uuidv4() })]);
  const [familyRelation, setFamilyRelation] = useState([
    createFamilyRelation({ id: uuidv4() }),
  ]);
  const [familyData, setFamilyData] = useState(null);
  console.log("familyData", familyData);

  const [showToast, setShowToast] = useState(null);
  const { id: familyId } = useParams();
  const userData = useSelector(selectUserProfile);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const addMember = () => {
    setMembers((prev) => [...prev, createMember({ id: uuidv4() })]);
  };

  const addFamilyRelation = () => {
    setFamilyRelation((prev) => [
      ...prev,
      createFamilyRelation({ id: uuidv4() }),
    ]);
  };

  const deleteMember = (id) => {
    const deletedMember = members.find((member) => member.id === id);

    setMembers((prevMembers) =>
      prevMembers.filter((member) => member.id !== id)
    );

    if (deletedMember) {
      const relatedMemberId = deletedMember.memberId;

      setFamilyRelation((prevFamilyRelation) =>
        prevFamilyRelation.filter(
          (familyMember) => familyMember.relatedMemberId !== relatedMemberId
        )
      );
    }
  };

  const deleteFamilyMember = (id) => {
    setFamilyRelation((prev) => prev.filter((f) => f.id !== id));
  };

  const updateMember = (updatedField, id) => {
    const index = members.findIndex((member) => member.id === id);

    const oldMember = members[index];
    const newMember = {
      ...oldMember,
      ...updatedField,
    };

    const newMembers = [...members];
    newMembers[index] = newMember;
    setMembers(newMembers);
  };

  const updateFamilyMember = (updatedField, id) => {
    const index = familyRelation.findIndex((member) => member.id === id);

    const oldFamilyMember = familyRelation[index];
    const newFamilyMember = {
      ...oldFamilyMember,
      ...updatedField,
    };

    const newFamilyMembers = [...familyRelation];
    newFamilyMembers[index] = newFamilyMember;
    setFamilyRelation(newFamilyMembers);
  };

  const checkFormData = (formData) => {
    let isValid = true;

    if (isEmptyObj(formData) || !members.length) {
      isValid = false;
    }

    for (const key of Object.keys(formData)) {
      const value = formData[key];
      if (key === FAMILY_FIELDS.PINCODE) {
        continue;
      } else if (!value) {
        isValid = false;
        break;
      }
    }

    return isValid;
  };

  const getRelations = () => {
    if (familyRelation.length) {
      return familyRelation.reduce((acc, curr) => {
        if (isValidFamiltMember(curr)) {
          const familyMember = { ...curr };
          delete familyMember.id;
          acc.push(familyMember);
        }
        return acc;
      }, []);
    }
    return [];
  };

  const onFormSubmit = async (values) => {
    if (!isEdit) {
      const isFormValid = checkFormData(values);
      if (!isFormValid) {
        setShowToast({
          message: "Form not valid",
          severity: "error",
        });
        return;
      }
    }

    try {
      const payload = {
        ...values,
        familyName: "DUMMY",
        memberIds: members.map((m) => m.memberId),
        relations: getRelations(),
      };
      await Family[isEdit ? "updateFamily" : "createFamily"](
        payload,
        familyData?.familyId ?? null
      );

      // setTimeout(() => {
      //   navigate(-2);
      // }, 2000);

      if (isEdit) {
        setTimeout(() => {
          navigate(-2);
        }, 2000);
      } else {
        setTimeout(() => {
          navigate("/members/family/detail");
        }, 2000);
      }

      setShowToast({
        message: isEdit
          ? "Family Updated Successfully"
          : "Family Created Successfully",
        severity: "success",
      });
    } catch (error) {
      setShowToast({
        message: error.message || "something went wrong, try again",
        severity: "error",
      });
      Sentry.captureException(error);
    }
  };

  const fetchFamilyDetails = async (id) => {
    try {
      const payload = {
        familyId: id,
        inOrganisationStructure: false,
      };
      setIsLoading(true);
      const [familyInfoData, familyRelationShips] = await Promise.all([
        Family.searchFamilyDetails({ query: payload }),
        Family.getRelationshipByFamilyId(id),
      ]);
      const familyInfo = familyInfoData.data.content[0];
      const familyRelationInfo = familyRelationShips.data;
      setFamilyData({
        ...familyInfo,
        familyRelationShips: familyRelationShips?.data ?? [],
      });

      if (familyInfo && familyInfo?.familyMembers?.length) {
        const newMembers = familyInfo.familyMembers.map((member) =>
          createMember({
            id: uuidv4(),
            memberId: member.memberId,
            name: member.fullName,
            isSameOrg:
              Number(userData.districtId) === Number(member.districtId),
            gohonzon: member?.gohonzonMemberships,
            subscription: member?.subscriptions,
            divisionName: member?.divisionName,
          })
        );
        setMembers(newMembers);
      }
      if (familyRelationInfo && familyRelationInfo.length) {
        const newFamilyMembers = familyRelationInfo.map((familyMember) =>
          createFamilyRelation({
            id: uuidv4(),
            memberId: familyMember.member.memberId,
            relatedMemberId: familyMember.relatedMember.memberId,
            relationType: familyMember.relationType,
          })
        );
        setFamilyRelation(newFamilyMembers);
      }
      setIsLoading(false);
    } catch (error) {
      Sentry.captureException(error);
    }
  };

  const { preview } = useParams();
  const isPreview = preview === "preview";

  const readOnly = isPreview;

  useEffect(() => {
    if (familyId) {
      fetchFamilyDetails(familyId);
    }
  }, [familyId]);

  const familyRelationOptions = useMemo(() => {
    if (members && members.length) {
      return members.map((member) => ({
        key: member.name,
        value: member.memberId,
      }));
    }
    return [];
  }, [members]);

  return (
    <>
      <Box style={Styles.container}>
        {isLoading && <Loader />}
        <Formik initialValues={{}} onSubmit={debounce(onFormSubmit)}>
          {({ values, errors, handleChange, handleSubmit, setFieldValue }) => (
            <>
              <Box style={Styles.topContainer}>
                <FamilySubHeader
                  label={
                    readOnly
                      ? "Family Members"
                      : isEdit
                      ? "Edit Family Member"
                      : "Add Member to Family"
                  }
                  // id={familyData ? familyData.familyId : null}
                />
                <Box style={Styles.main}>
                  {members.map((member, index) => (
                    <MemberRow
                      index={index}
                      key={member.id}
                      member={member}
                      deleteMember={deleteMember}
                      updateMember={updateMember}
                      setFieldValue={setFieldValue}
                      isEdit={isEdit}
                      readOnly={readOnly}
                    />
                  ))}
                </Box>
                {!readOnly && (
                  <Typography
                    as="span"
                    style={Styles.addLink}
                    onClick={addMember}
                  >
                    Add Another
                  </Typography>
                )}
              </Box>
              <Divider style={Styles.divider} />
              <Box>
                <Typography
                  style={{
                    color: "#8C8C8C",
                    fontSize: 20,
                    marginLeft: "30px",
                    marginTop: "20px",
                    margin: "20px 0px",
                  }}
                  variant="title2"
                >
                  {readOnly ? "Family Relations" : "Add Family Relations"}
                </Typography>
                {familyRelation.map((familyMember, index) => (
                  <FamilyRelation
                    key={familyMember.id}
                    index={index}
                    familyMember={familyMember}
                    deleteFamilyMember={deleteFamilyMember}
                    options={familyRelationOptions}
                    updateFamilyMember={updateFamilyMember}
                    readOnly={readOnly}
                  />
                ))}
              </Box>
              <Box
                style={readOnly ? { marginTop: "20px" } : { marginTop: "30px" }}
              >
                {!readOnly && (
                  <Typography
                    as="span"
                    style={Styles.addLink}
                    onClick={addFamilyRelation}
                  >
                    Add Another
                  </Typography>
                )}
              </Box>
              <Divider style={Styles.divider} />

              <div>
                <Typography style={Styles.addressText} variant="title2">
                  Address Details
                </Typography>
              </div>

              <Box style={Styles.addressForm}>
                <AddressForm
                  values={values}
                  errors={errors}
                  handleChange={handleChange}
                  handleSubmit={handleSubmit}
                  setFieldValue={setFieldValue}
                  familyData={familyData}
                  readOnly={readOnly}
                />
              </Box>
            </>
          )}
        </Formik>
      </Box>
      <Toast
        open={!!showToast}
        severity={showToast?.severity || ""}
        message={showToast?.message || ""}
        handleClose={() => {
          setShowToast(null);
        }}
      />
    </>
  );
}

export default FamilyForm;
